import { StateCreator } from 'zustand';
import { UtilsSlice } from './utils.types';

export const createUtilsSlice: StateCreator<
  UtilsSlice,
  [],
  [],
  UtilsSlice
> = () => ({
  footerHeight: 250,
});
